import {
  getAvailabilityRangesForDate,
  hasUnavailableBusyIntervals,
  isBookingRangeAvailable,
  timeToMinutes,
} from "./studioAvailability";

const HOUR_IN_MINUTES = 60;
const DAY_IN_MINUTES = 24 * HOUR_IN_MINUTES;

const normalizeDurationHours = (durationHours) => {
  const normalized = Number(durationHours);
  return normalized > 0 ? normalized : 1;
};

const minutesToHourTime = (minutes) => {
  if (minutes >= DAY_IN_MINUTES) return "24:00";

  const hour = Math.floor(minutes / HOUR_IN_MINUTES);
  return `${String(hour).padStart(2, "0")}:00`;
};

const sortTimeSlots = (slots) =>
  [...slots].sort((a, b) => timeToMinutes(a) - timeToMinutes(b));

export const getInquiryStartTimeSlots = ({
  dateString,
  bookingStudioData,
  minHours = 1,
  includeCurrentTimeBuffer = true,
} = {}) => {
  if (!dateString || hasUnavailableBusyIntervals(bookingStudioData)) return [];

  const durationHours = normalizeDurationHours(minHours);
  const durationMinutes = durationHours * HOUR_IN_MINUTES;
  const slots = new Set();

  getAvailabilityRangesForDate(dateString, bookingStudioData).forEach((range) => {
    const rangeStart = timeToMinutes(range.start);
    const rangeEnd = timeToMinutes(range.end, { endOfRange: true });
    const latestStart = rangeEnd - durationMinutes;

    for (
      let minutes = Math.ceil(rangeStart / HOUR_IN_MINUTES) * HOUR_IN_MINUTES;
      minutes <= latestStart;
      minutes += HOUR_IN_MINUTES
    ) {
      const time = minutesToHourTime(minutes);
      if (
        isBookingRangeAvailable(dateString, time, durationHours, bookingStudioData, {
          includeCurrentTimeBuffer,
        })
      ) {
        slots.add(time);
      }
    }
  });

  return sortTimeSlots(slots);
};

export const getInquiryEndTimeSlots = ({
  dateString,
  startTime,
  bookingStudioData,
  minHours = 1,
  includeCurrentTimeBuffer = true,
} = {}) => {
  if (!dateString || !startTime || hasUnavailableBusyIntervals(bookingStudioData)) {
    return [];
  }

  const startMinutes = timeToMinutes(startTime);
  const minDurationHours = normalizeDurationHours(minHours);
  const minDurationMinutes = minDurationHours * HOUR_IN_MINUTES;
  const ranges = getAvailabilityRangesForDate(dateString, bookingStudioData);
  const activeRange = ranges.find((range) => {
    const rangeStart = timeToMinutes(range.start);
    const rangeEnd = timeToMinutes(range.end, { endOfRange: true });
    return startMinutes >= rangeStart && startMinutes < rangeEnd;
  });

  if (!activeRange) return [];

  const rangeEnd = timeToMinutes(activeRange.end, { endOfRange: true });
  const slots = [];

  for (
    let endMinutes = startMinutes + minDurationMinutes;
    endMinutes <= rangeEnd;
    endMinutes += HOUR_IN_MINUTES
  ) {
    const durationHours = (endMinutes - startMinutes) / HOUR_IN_MINUTES;
    if (
      isBookingRangeAvailable(dateString, startTime, durationHours, bookingStudioData, {
        includeCurrentTimeBuffer,
      })
    ) {
      slots.push(minutesToHourTime(endMinutes));
    }
  }

  return slots;
};
